import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import PaymentResult from "@/pages/PaymentResult";

function App() {
  return (
    <div className="App">
      <div className="grain" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentResult variant="success" />} />
          <Route path="/payment/cancel" element={<PaymentResult variant="cancel" />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
